import { DashboardModuleListItem } from '@domain-group/suit-theme'

import useServiceCategory from '@hooks/useServiceCategory'

import type { ServiceCategoryModel } from '@models/types'

const ServiceCategoryListItem = (props: { serviceCategory: ServiceCategoryModel }) => {
  const { serviceCategory, serviceCategory: { title } } = props

  const serviceCategoryPayload = useServiceCategory(serviceCategory)
  const {
    callbacks: { createOrEditServiceCategory },
    service: { title: serviceTitle },
  } = serviceCategoryPayload

  return (
    <DashboardModuleListItem
      onClick={() => createOrEditServiceCategory()}
      title={title}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText>
        {serviceTitle}
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.TertiaryText>
    </DashboardModuleListItem>
  )
}

export default ServiceCategoryListItem
